export const BOOKING_NAVIGATION = {
  VISIT: 'visit',
  INFORMATION: 'information',
}
